var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active-appointments-index"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":[
      { title: this.$t(`menu.${this.serviceSlug}`)},
      { title: this.$t('clinical.appointments.active_appointments'), disabled: true }
    ]}}),_c('ActiveAppointmentsTable',{attrs:{"service-slug":this.serviceSlug}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }